<template>
  <div />
</template>

<script setup lang="ts">
import { LngLatBounds, type Map as MapLibreMap } from 'maplibre-gl'

const props = withDefaults(
  defineProps<{
    points: [number, number][]
    map: MapLibreMap
    padding?: number | { top: number; right: number; bottom: number; left: number }
    // Zoom level for single points (for flyTo)
    zoom?: number
    duration?: number
    disabled?: boolean
  }>(),
  {
    padding: 100,
    duration: 500,
    zoom: 15
  }
)

const emit = defineEmits<{
  (e: 'onZoomEnd', map: MapLibreMap): void
}>()

const arePointsEqual = (a: [number, number][], b: [number, number][]) => {
  if (a === b) return true
  if (a.length !== b.length) return false

  for (let i = 0; i < a.length; i++) {
    if (a[i][0] !== b[i][0] || a[i][1] !== b[i][1]) return false
  }

  return true
}

const center = () => {
  if (props.points.length === 0) return

  const bounds = new LngLatBounds()

  for (const point of props.points) {
    bounds.extend(point)
  }

  // aka bounding box that really is a single point
  if (bounds.getEast() === bounds.getWest() && bounds.getNorth() === bounds.getSouth()) {
    props.map.flyTo({
      center: [bounds.getCenter().lng, bounds.getCenter().lat],
      zoom: props.zoom,
      duration: props.duration
    })
  } else {
    props.map.fitBounds(bounds, {
      padding: props.padding,
      duration: props.duration
    })
  }

  const callback = () => {
    props.map.off('moveend', callback)
    emit('onZoomEnd', props.map)
  }

  props.map.on('moveend', callback)
}

watch(
  () => props.points,
  (newValue, oldValue) => {
    if (props.disabled) return

    if (oldValue && arePointsEqual(newValue, oldValue)) return

    center()
  }
)

onMounted(() => {
  if (props.disabled) return

  center()
})
</script>
